import React, { useEffect, createElement } from 'react';
import { CheckCircle2Icon, XCircleIcon, StarIcon, ShieldCheckIcon, ZapIcon, UsersIcon, BookOpenIcon, GiftIcon, ArrowRightIcon, LockIcon, CreditCardIcon, GlobeIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { Timer } from './components/Timer';
import { Roadmap } from './components/Roadmap';
import { Accordion } from './components/Accordion';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel Initialization
    const initMetaPixel = () => {
      // @ts-ignore
      if (window.fbq) return;
      // @ts-ignore
      const n = window.fbq = function () {
        // @ts-ignore
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = n;
      // @ts-ignore
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      // @ts-ignore
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      // @ts-ignore
      fbq('init', '1313291250496067');
      // @ts-ignore
      fbq('track', 'PageView');
    };
    initMetaPixel();
  }, []);
  return <div className="min-h-screen selection:bg-brand-green selection:text-black" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      {/* Sticky Header */}
      <header className="sticky top-0 z-50 bg-brand-navy/90 backdrop-blur-md border-b border-white/10 py-3 px-4" data-id="element-2">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-3">
          <div className="flex items-center gap-2" data-id="element-4">
            <div className="w-8 h-8 bg-brand-green rounded flex items-center justify-center text-black font-black" data-id="element-5">
              F
            </div>
            <span className="font-montserrat font-extrabold text-xl tracking-tighter" data-id="element-6">
              F500 FREELANCE<span className="text-brand-green" data-id="element-7">™</span>
            </span>
          </div>
          <a href="#pricing" className="bg-brand-green text-black px-4 py-2 rounded-full font-montserrat font-bold text-sm hover:scale-105 transition-transform neon-glow hidden md:block" data-id="element-8">
            QUIERO MI F500
          </a>
        </div>
      </header>

      <main data-id="element-9">
        {/* Hero Section */}
        <section className="relative pt-8 pb-6 md:pt-20 md:pb-16 px-4 overflow-hidden" data-id="element-10">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(0,212,170,0.1)_0%,transparent_70%)] pointer-events-none" data-id="element-11" />
          <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-12">
            <div className="inline-block bg-brand-green/10 text-brand-green border border-brand-green/20 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-13">
              🟢 TU PRIMER $500 COMO FREELANCER. LISTO.
            </div>
            <h1 className="text-4xl md:text-7xl font-black mb-6 leading-tight" data-id="element-14">
              En menos de{' '}
              <div className="text-brand-green underline decoration-brand-green/30" data-id="element-15">
                30 días.
              </div>
            </h1>

            <div className="mb-6 md:mb-10 flex justify-center" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/d2pU9pf7oy1pqSo1psScQQ/f500_mobile_768.webp" alt="F500 Mega Pack Mockup" className="w-full max-w-2xl rounded-2xl shadow-2xl shadow-brand-green/10 border border-white/5" data-id="element-17" />
            </div>

            <p className="text-xl md:text-2xl text-gray-300 mb-6 md:mb-8 max-w-2xl mx-auto" data-id="element-18">
              F500 Freelance MegaPack — El sistema N°1 para ganar en dólares
              desde Latinoamérica sin experiencia previa.
            </p>

            <div className="flex flex-col items-center gap-4" data-id="element-19">
              <a href="#pricing" className="w-full md:w-auto bg-brand-green text-black px-10 py-5 rounded-xl font-montserrat font-black text-xl hover:scale-105 transition-all neon-glow flex items-center justify-center gap-2 group" data-id="element-20">
                QUIERO MI F500 AHORA{' '}
                <ArrowRightIcon className="group-hover:translate-x-1 transition-transform" data-id="element-21" />
              </a>
              <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mt-4" data-id="element-22">
                <span className="flex items-center gap-1" data-id="element-23">
                  <ShieldCheckIcon size={16} className="text-brand-green" data-id="element-24" />{' '}
                  Garantía 7 días
                </span>
                <span className="flex items-center gap-1" data-id="element-25">
                  <LockIcon size={16} className="text-brand-green" data-id="element-26" /> Pago
                  seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-27">
                  <CreditCardIcon size={16} className="text-brand-green" data-id="element-28" />{' '}
                  Mercado Pago
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Social Proof Stats */}
        <section className="bg-brand-darker border-y border-white/5 py-6 md:py-10 px-4" data-id="element-29">
          <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-30">
            <div data-id="element-31">
              <div className="text-4xl font-black text-brand-green mb-1" data-id="element-32">
                +500
              </div>
              <div className="text-xs uppercase tracking-widest text-gray-400" data-id="element-33">
                Compradores confían
              </div>
            </div>
            <div data-id="element-34">
              <div className="text-4xl font-black text-brand-green mb-1" data-id="element-35">5</div>
              <div className="text-xs uppercase tracking-widest text-gray-400" data-id="element-36">
                Tomos listos
              </div>
            </div>
            <div data-id="element-37">
              <div className="text-4xl font-black text-brand-green mb-1" data-id="element-38">3</div>
              <div className="text-xs uppercase tracking-widest text-gray-400" data-id="element-39">
                Bonos incluidos
              </div>
            </div>
            <div data-id="element-40">
              <div className="text-4xl font-black text-brand-green mb-1" data-id="element-41">
                4,9/5
              </div>
              <div className="text-xs uppercase tracking-widest text-gray-400" data-id="element-42">
                Calificación ⭐
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Hero */}
        <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto" data-id="element-43">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-44">
            {[{
            name: 'Valentina L.',
            loc: 'Mendoza',
            role: 'Community Manager',
            text: 'Apliqué el Tomo 3 en la semana 2 y cerré mi primer cliente de $120. Nunca había ganado un dólar online.'
          }, {
            name: 'Rodrigo C.',
            loc: 'Bogotá',
            role: 'Redactor SEO',
            text: 'Las 100 plantillas del Bono 1 me ahorraron horas de trabajo. Solo copio, personalizo y envío. El 30% de mis propuestas responden.'
          }, {
            name: 'Sofía M.',
            loc: 'CDMX',
            role: 'VA Freelancer',
            text: 'En el Día 28 ya tenía $480 facturados. El sistema funciona exactamente como dice. El Tomo 4 de automatización fue clave.'
          }].map((t, i) => <div key={i} className="bg-white/5 border border-white/10 p-8 rounded-2xl" data-id="element-45">
                <div className="flex gap-1 mb-4" data-id="element-46">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="fill-brand-gold text-brand-gold" data-id="element-47" />)}
                </div>
                <p className="text-lg mb-6 italic text-gray-200" data-id="element-48">"{t.text}"</p>
                <div className="flex items-center gap-3" data-id="element-49">
                  <div className="w-10 h-10 bg-brand-green/20 rounded-full flex items-center justify-center text-brand-green font-bold" data-id="element-50">
                    {t.name[0]}
                  </div>
                  <div data-id="element-51">
                    <div className="font-bold" data-id="element-52">{t.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-53">
                      {t.loc} · {t.role}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        {/* Pain Points Section */}
        <section className="py-8 md:py-20 px-4 bg-brand-darker" data-id="element-54">
          <div className="max-w-4xl mx-auto" data-id="element-55">
            <h2 className="text-3xl md:text-5xl font-black mb-6 md:mb-8 text-center" data-id="element-56">
              ¿Cuántos meses más vas a seguir ganando en pesos mientras otros{' '}
              <span className="text-brand-green" data-id="element-57">ganan en dólares</span> desde
              su casa?
            </h2>
            <p className="text-gray-400 text-center mb-12 text-lg" data-id="element-58">
              Querés ganar en dólares online. Sabés que hay personas en Latam
              que lo hacen desde una laptop. Pero nadie te dijo exactamente cómo
              arrancar sin experiencia previa. No es falta de talento. Es falta
              de un sistema.
            </p>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-59">
              {['Creaste perfil en Upwork pero nadie te responde', 'No sabés qué nicho elegir y aplicás a todo', 'Escribís propuestas genéricas que van al archivo', 'Tenés habilidades pero no sabés cómo mostrarlas', 'Ves videos de YouTube pero sin sistema completo', 'Inflación en Argentina y el sueldo no alcanza', 'Otro mes pasa y seguís en $0 freelance'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-white/5 p-4 rounded-lg border border-white/5" data-id="element-60">
                  <XCircleIcon className="text-red-500 shrink-0 mt-1" size={20} data-id="element-61" />
                  <span className="text-gray-200" data-id="element-62">{item}</span>
                </div>)}
            </div>
            <div className="mt-8 text-center" data-id="element-63">
              <p className="text-2xl font-bold text-brand-green" data-id="element-64">
                ¿Y si este fuera el último mes que pasaste sin ganar en dólares?
              </p>
            </div>
          </div>
        </section>

        {/* Solution / Product Reveal */}
        <section className="py-8 md:py-20 px-4 max-w-5xl mx-auto" data-id="element-65">
          <div className="text-center mb-8 md:mb-16" data-id="element-66">
            <h2 className="text-4xl md:text-6xl font-black mb-6" data-id="element-67">
              🏆 F500 FREELANCE™ MEGAPACK
            </h2>
            <p className="text-xl text-brand-green font-bold mb-4" data-id="element-68">
              5 Tomos + 3 Bonos — Días 1 al 30
            </p>
            <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-69">
              El roadmap exacto de 30 días que llevó a +500 freelancers en Latam
              de $0 a su primer $500 real en dólares.
            </p>
          </div>

          <div className="bg-brand-darker border border-brand-green/30 rounded-3xl p-6 md:p-12 mb-8 md:mb-20" data-id="element-70">
            <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-71">
              TU ROADMAP DE 30 DÍAS
            </h3>
            <Roadmap data-id="element-72" />
          </div>

          <div className="space-y-4" data-id="element-73">
            <h3 className="text-3xl font-black mb-8 flex items-center gap-3" data-id="element-74">
              <BookOpenIcon className="text-brand-green" data-id="element-75" /> 5 TOMOS COMPLETOS
            </h3>

            <Accordion title="📘 TOMO 1 — DÍAS 1 AL 7: Encuentra Tu Nicho + Perfil Pro" data-id="element-76">
              <p className="mb-4" data-id="element-77">
                Quiz de nicho, 20 nichos calientes Latam, perfil Upwork/Fiverr
                al 100%, keywords SEO, estrategia de precio escalera F500.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-78">
                Meta Día 7: Perfil activo + primer gig publicado.
              </div>
            </Accordion>

            <Accordion title="📗 TOMO 2 — DÍAS 8 AL 14: Portfolio Irresistible" colorClass="border-green-500" data-id="element-79">
              <p className="mb-4" data-id="element-80">
                30 plantillas Canva por nicho, método portfolio sin experiencia,
                before/after que impacta, primeras reseñas 5 estrellas.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-81">
                Meta Día 14: Portfolio activo + invitación cliente.
              </div>
            </Accordion>

            <Accordion title="📙 TOMO 3 — DÍAS 15 AL 21: Propuestas que Cierran" colorClass="border-orange-500" data-id="element-82">
              <p className="mb-4" data-id="element-83">
                Fórmula P.R.O.F.500, 50 propuestas copy/paste, manejo
                objeciones, follow-up 5 toques, IA para propuestas en 3 minutos.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-84">
                Meta Día 21: Primer $100 real garantizado.
              </div>
            </Accordion>

            <Accordion title="📕 TOMO 4 — DÍAS 22 AL 28: Escala a $500" colorClass="border-red-500" data-id="element-85">
              <p className="mb-4" data-id="element-86">
                Upsells que multiplican x3, Zapier + Calendly automatizados, CRM
                Notion, rutina 2h/día, tracker ingresos, clientes recurrentes.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-87">
                Meta Día 28: $400+ acumulados confirmados.
              </div>
            </Accordion>

            <Accordion title="📓 TOMO 5 — DÍAS 29 AL 30+: Retención + $1K Forever" colorClass="border-gray-500" data-id="element-88">
              <p className="mb-4" data-id="element-89">
                Sistema retención 7 pasos, nurture clientes, plan $1k mes 2,
                subcontratación, ingresos semi-pasivos, roadmap $1k→$2k→$5k.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-90">
                Meta Día 30: $500 LOCKED + base $1k construida.
              </div>
            </Accordion>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-91">
            {['Roadmap diario', 'Templates listos', 'Casos de éxito', 'Trackers progreso'].map((item, i) => <div key={i} className="flex items-center gap-2 text-sm text-gray-300" data-id="element-92">
                <CheckCircle2Icon size={16} className="text-brand-green" data-id="element-93" />{' '}
                {item}
              </div>)}
          </div>
        </section>

        {/* Bonuses Section */}
        <section className="py-8 md:py-20 px-4 bg-brand-darker" data-id="element-94">
          <div className="max-w-6xl mx-auto" data-id="element-95">
            <h2 className="text-3xl md:text-5xl font-black mb-8 md:mb-12 text-center" data-id="element-96">
              🎁 3 BONOS ESTRATÉGICOS{' '}
              <span className="text-brand-green" data-id="element-97">INCLUIDOS</span>
            </h2>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-98">
              {[{
              title: '100 Plantillas de Propuestas',
              price: '$97 USD',
              desc: 'Copia, personaliza en 3 minutos y enviá. 100 templates por nicho: redacción, diseño, VA, marketing e IA.'
            }, {
              title: 'Scripts Emails + Prompts IA',
              price: '$67 USD',
              desc: '50 emails listos para cada situación + 20 prompts ChatGPT para generar propuestas profesionales en 60 segundos.'
            }, {
              title: 'Lista 200 Leads Latam',
              price: '$127 USD',
              desc: '200 prospectos calificados organizados por nicho y país + sistema completo para convertirlos en clientes sin plataformas.'
            }].map((bono, i) => <div key={i} className="bg-brand-navy border border-white/10 p-8 rounded-2xl relative overflow-hidden group" data-id="element-99">
                  <div className="absolute top-0 right-0 bg-brand-green text-black px-4 py-1 font-bold text-xs" data-id="element-100">
                    GRATIS
                  </div>
                  <div className="text-brand-green font-black text-4xl mb-4" data-id="element-101">
                    0{i + 1}
                  </div>
                  <h3 className="text-xl font-bold mb-4" data-id="element-102">{bono.title}</h3>
                  <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-103">
                    {bono.desc}
                  </p>
                  <div className="text-gray-500 line-through text-sm" data-id="element-104">
                    {bono.price}
                  </div>
                  <div className="text-brand-green font-bold" data-id="element-105">
                    GRATIS con tu F500
                  </div>
                </div>)}
            </div>
            <div className="mt-10 text-center bg-brand-green/5 border border-brand-green/20 p-6 rounded-xl" data-id="element-106">
              <span className="text-xl" data-id="element-107">
                Valor total bonos:{' '}
                <span className="line-through text-gray-500" data-id="element-108">$291 USD</span> →{' '}
                <span className="text-brand-green font-black" data-id="element-109">
                  GRATIS con tu MegaPack
                </span>
              </span>
            </div>
          </div>
        </section>

        {/* Urgency & Pricing */}
        <section id="pricing" className="py-8 md:py-20 px-4" data-id="element-110">
          <div className="max-w-4xl mx-auto text-center mb-8 md:mb-12" data-id="element-111">
            <h2 className="text-2xl font-bold text-red-500 mb-4 flex items-center justify-center gap-2" data-id="element-112">
              <ZapIcon size={20} data-id="element-113" /> PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>
            <Timer data-id="element-114" />
            <p className="mt-6 text-gray-400" data-id="element-115">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>

            <div className="mt-8 max-w-md mx-auto" data-id="element-116">
              <div className="flex justify-between text-sm mb-2" data-id="element-117">
                <span data-id="element-118">Cupos al precio de lanzamiento</span>
                <span className="text-brand-green font-bold" data-id="element-119">68% vendidos</span>
              </div>
              <div className="w-full h-3 bg-gray-800 rounded-full overflow-hidden" data-id="element-120">
                <div className="h-full bg-brand-green w-[68%] shadow-[0_0_10px_#00D4AA]" data-id="element-121" />
              </div>
            </div>
          </div>

          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-122">
            {/* Standard Plan */}
            <div className="bg-white/5 border border-white/10 p-8 rounded-3xl flex flex-col" data-id="element-123">
              <h3 className="text-2xl font-black mb-2" data-id="element-124">📘 F500 MEGAPACK</h3>
              <p className="text-gray-400 text-sm mb-6 italic" data-id="element-125">
                Ideal para: Freelancers que arrancan de cero y quieren $500 en
                30 días
              </p>
              <div className="mb-8" data-id="element-126">
                <div className="text-gray-500 line-through text-lg" data-id="element-127">
                  $536 USD
                </div>
                <div className="text-4xl font-black text-white" data-id="element-128">
                  $19.990{' '}
                  <span className="text-sm font-normal text-gray-400" data-id="element-129">ARS</span>
                </div>
              </div>
              <ul className="space-y-3 mb-10 flex-grow" data-id="element-130">
                {['5 Tomos Completos', '3 Bonos Estratégicos', 'Acceso de por vida', 'Actualizaciones gratis'].map((item, i) => <li key={i} className="flex items-center gap-2 text-sm" data-id="element-131">
                    <CheckCircle2Icon size={16} className="text-brand-green" data-id="element-132" />{' '}
                    {item}
                  </li>)}
              </ul>
              <a href="https://checkout.guiadigital360.online/cart/44854830039109:1" className="w-full bg-white/10 hover:bg-white/20 text-white py-4 rounded-xl font-bold transition-all text-center" data-id="element-133">
                QUIERO MI F500 AHORA
              </a>
            </div>

            {/* Elite Plan */}
            <div className="bg-brand-darker border-2 border-brand-gold p-8 rounded-3xl flex flex-col relative gold-glow" data-id="element-134">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-black px-6 py-1 rounded-full font-black text-sm" data-id="element-135">
                MÁS ELEGIDO ⭐
              </div>
              <h3 className="text-2xl font-black mb-2 text-brand-gold" data-id="element-136">
                🏆 F500 ELITE
              </h3>
              <p className="text-gray-400 text-sm mb-6 italic" data-id="element-137">
                Ideal para: Quien quiere resultado garantizado con
                acompañamiento real
              </p>
              <div className="mb-8" data-id="element-138">
                <div className="text-gray-500 line-through text-lg" data-id="element-139">
                  $736 USD
                </div>
                <div className="text-4xl font-black text-brand-gold" data-id="element-140">
                  $24.990{' '}
                  <span className="text-sm font-normal text-gray-400" data-id="element-141">ARS</span>
                </div>
              </div>
              <ul className="space-y-3 mb-10 flex-grow" data-id="element-142">
                {['Todo lo del MegaPack', 'Comunidad Privada (Telegram)', '1 Sesión Coaching Grupal Mensual', 'Feedback de tus propuestas', 'Certificado F500 Oficial', 'Canal prioritario soporte'].map((item, i) => <li key={i} className="flex items-center gap-2 text-sm" data-id="element-143">
                    <CheckCircle2Icon size={16} className="text-brand-gold" data-id="element-144" />{' '}
                    {item}
                  </li>)}
              </ul>
              <button className="w-full bg-brand-gold text-black py-4 rounded-xl font-black text-lg hover:scale-[1.02] transition-all shadow-lg" data-id="element-145">
                QUIERO EL F500 ELITE
              </button>
            </div>
          </div>
        </section>

        {/* Elite Comparison Table */}
        <section className="py-8 md:py-20 px-4 bg-brand-darker overflow-x-auto" data-id="element-146">
          <div className="max-w-4xl mx-auto" data-id="element-147">
            <h2 className="text-3xl font-black mb-8 md:mb-12 text-center" data-id="element-148">
              🕊️ ¿QUÉ AGREGA EL PLAN ELITE?
            </h2>
            <table className="w-full border-collapse" data-id="element-149">
              <thead data-id="element-150">
                <tr className="border-b border-white/10" data-id="element-151">
                  <th className="p-4 text-left text-gray-400 font-medium" data-id="element-152">
                    Situación
                  </th>
                  <th className="p-4 text-center text-red-400 font-medium" data-id="element-153">
                    Sin Elite ❌
                  </th>
                  <th className="p-4 text-center text-brand-green font-medium" data-id="element-154">
                    Con Elite ✅
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm" data-id="element-155">
                {[['Duda en semana 1', 'Buscás solo en YouTube', 'Respuesta en comunidad'], ['Propuesta no convierte', 'Seguís enviando igual', 'Feedback real de guía'], ['Primer cliente rechaza', 'Bajás el precio sin sistema', 'Script exacto para mantenerlo'], ['Semana 3 sin respuestas', 'Desesperación y abandono', 'Ajuste estratégico en vivo'], ['Llegaste a $300 y frenaste', 'No sabés qué cambiar', 'Sesión grupal de escala']].map((row, i) => <tr key={i} className="border-b border-white/5 hover:bg-white/5" data-id="element-156">
                    <td className="p-4 font-bold" data-id="element-157">{row[0]}</td>
                    <td className="p-4 text-center text-gray-400" data-id="element-158">{row[1]}</td>
                    <td className="p-4 text-center text-brand-green font-bold" data-id="element-159">
                      {row[2]}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </section>

        {/* More Testimonials */}
        <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto" data-id="element-160">
          <h2 className="text-3xl font-black mb-8 md:mb-12 text-center" data-id="element-161">
            ❤️ MÁS FREELANCERS QUE YA LO TIENEN
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-162">
            {[{
            name: 'Nicolás R.',
            loc: 'Rosario',
            text: 'Configuré los flujos Zapier del Tomo 4 y ahorro 6 horas semanales. Con eso consigo más clientes. El sistema funciona.'
          }, {
            name: 'Fernanda C.',
            loc: 'Guadalajara',
            text: 'En el Día 14 ya tenía portfolio y 2 reseñas. El método de portfolio sin experiencia del Tomo 2 fue lo que lo cambió todo.'
          }, {
            name: 'Sebastián B.',
            loc: 'Bogotá',
            text: 'La sesión grupal de coaching me ayudó a identificar por qué mis propuestas no cerraban. En 3 días corregí y empecé a convertir al 35%. Impagable.'
          }, {
            name: 'Isabella B.',
            loc: 'Lima',
            text: 'Día 30: $710 USD facturados. Superé la meta del sistema. El Bono 3 de leads fue lo que me dio los primeros clientes directos.'
          }].map((t, i) => <div key={i} className="bg-white/5 p-6 rounded-xl border border-white/5" data-id="element-163">
                <div className="flex gap-1 mb-3" data-id="element-164">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} className="fill-brand-gold text-brand-gold" data-id="element-165" />)}
                </div>
                <p className="text-gray-300 mb-4 italic" data-id="element-166">"{t.text}"</p>
                <div className="text-sm font-bold" data-id="element-167">
                  {t.name} |{' '}
                  <span className="font-normal text-gray-500" data-id="element-168">{t.loc}</span>
                </div>
              </div>)}
          </div>
        </section>

        {/* Warranty */}
        <section className="py-8 md:py-20 px-4 bg-brand-green text-black" data-id="element-169">
          <div className="max-w-3xl mx-auto text-center" data-id="element-170">
            <img src="https://cdn.magicpatterns.com/uploads/o7VthJoAwGFw18vUMubnJs/garantia-7-dias-250.webp" alt="Garantía 7 Días" className="mx-auto mb-6 w-32 h-32 object-contain" data-id="element-171" />
            <h2 className="text-4xl font-black mb-6" data-id="element-172">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="text-xl font-medium mb-8" data-id="element-173">
              Abrís los tomos. Aplicás el sistema. Enviás tus primeras
              propuestas. Si en 7 días no es lo que esperabas: devolución del
              100% sin formularios, sin drama, sin vueltas.
            </p>
            <div className="text-sm font-bold uppercase tracking-widest opacity-70" data-id="element-174">
              Tasa de devoluciones: menos del 1%
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-8 md:py-20 px-4 max-w-3xl mx-auto" data-id="element-175">
          <h2 className="text-3xl font-black mb-8 md:mb-12 text-center" data-id="element-176">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="space-y-2" data-id="element-177">
            {[{
            q: '¿Necesito experiencia previa?',
            a: 'No. El sistema F500 está diseñado específicamente para empezar desde cero. El Tomo 1 te guía desde elegir tu nicho hasta publicar tu primer gig activo.'
          }, {
            q: '¿Cómo recibo el material?',
            a: 'En menos de 5 minutos después de tu pago recibirás un email con el link de acceso a tu carpeta Drive personal con los 5 Tomos + 3 Bonos completos.'
          }, {
            q: '¿Funciona para toda Latam?',
            a: 'Está diseñado en español neutro universal para toda Latinoamérica. Los casos, ejemplos y estrategias aplican para Argentina, México, Colombia, Perú, Chile y cualquier país hispanohablante.'
          }, {
            q: '¿Diferencia con YouTube?',
            a: 'Los videos de YouTube te dan información fragmentada. F500 te da un sistema completo de 30 días con tareas diarias concretas, plantillas listas para usar y tracking de progreso.'
          }, {
            q: '¿Tiene garantía real?',
            a: 'Sí. 7 días de garantía total sin preguntas. Si no es lo que esperabas te devolvemos el 100% del dinero. Sin drama.'
          }, {
            q: '¿Funciona si trabajo?',
            a: 'Sí. El sistema F500 está diseñado para 2 horas diarias máximo. Podés aplicarlo junto a tu trabajo actual hasta que tus ingresos freelance superen tu sueldo.'
          }].map((faq, i) => <Accordion key={i} title={faq.q} colorClass="border-brand-green/30" data-id="element-178">
                {faq.a}
              </Accordion>)}
          </div>
        </section>

        {/* Cost vs Benefit Table */}
        <section className="py-8 md:py-20 px-4 bg-brand-darker" data-id="element-179">
          <div className="max-w-4xl mx-auto" data-id="element-180">
            <h2 className="text-3xl font-black mb-8 md:mb-12 text-center" data-id="element-181">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-182">
              <div className="bg-red-500/5 border border-red-500/20 p-8 rounded-2xl" data-id="element-183">
                <h3 className="text-red-500 font-bold mb-6 flex items-center gap-2" data-id="element-184">
                  <XCircleIcon size={20} data-id="element-185" /> Sin F500
                </h3>
                <ul className="space-y-4 text-sm text-gray-400" data-id="element-186">
                  <li data-id="element-187">Meses enviando propuestas sin sistema</li>
                  <li data-id="element-188">Cursos sueltos sin resultado ($50-200 USD)</li>
                  <li data-id="element-189">Perfil Upwork sin optimización (0 clientes)</li>
                  <li data-id="element-190">Propuestas genéricas que nadie lee</li>
                  <li data-id="element-191">Otro mes en pesos sin ganar dólares</li>
                </ul>
              </div>
              <div className="bg-brand-green/5 border border-brand-green/20 p-8 rounded-2xl" data-id="element-192">
                <h3 className="text-brand-green font-bold mb-6 flex items-center gap-2" data-id="element-193">
                  <CheckCircle2Icon size={20} data-id="element-194" /> Con F500
                </h3>
                <ul className="space-y-4 text-sm text-gray-200" data-id="element-195">
                  <li className="font-bold" data-id="element-196">Sistema probado de 30 días</li>
                  <li className="font-bold" data-id="element-197">
                    Templates copy/paste que convierten
                  </li>
                  <li className="font-bold" data-id="element-198">
                    Perfil optimizado desde el Día 7
                  </li>
                  <li className="font-bold" data-id="element-199">
                    Roadmap claro hacia los $1.000/mes
                  </li>
                  <li className="font-bold text-brand-green" data-id="element-200">
                    Primeros $500 en dólares asegurados
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-12 text-center italic text-xl text-gray-400" data-id="element-201">
              "El sistema que te faltaba ya existe. Se llama F500."
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-8 md:py-20 px-4 bg-brand-navy relative overflow-hidden" data-id="element-202">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,rgba(0,212,170,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-203" />
          <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-204">
            <h2 className="text-3xl md:text-5xl font-black mb-8" data-id="element-205">
              EL PRÓXIMO MES PUEDE SER DIFERENTE.
            </h2>
            <div className="mb-12" data-id="element-206">
              <Timer data-id="element-207" />
            </div>

            <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-208">
              <a href="#pricing" className="bg-white/5 border border-white/10 p-6 rounded-2xl hover:bg-white/10 transition-all group" data-id="element-209">
                <div className="text-xl font-bold mb-2" data-id="element-210">MEGAPACK</div>
                <div className="text-brand-green font-black text-2xl mb-4" data-id="element-211">
                  $19.990 ARS
                </div>
                <div className="text-xs text-gray-400 group-hover:text-white flex items-center justify-center gap-1" data-id="element-212">
                  QUIERO MI F500 <ArrowRightIcon size={14} data-id="element-213" />
                </div>
              </a>
              <a href="#pricing" className="bg-brand-gold/10 border border-brand-gold/30 p-6 rounded-2xl hover:bg-brand-gold/20 transition-all group" data-id="element-214">
                <div className="text-xl font-bold mb-2 text-brand-gold" data-id="element-215">
                  ELITE ⭐
                </div>
                <div className="text-brand-gold font-black text-2xl mb-4" data-id="element-216">
                  $24.990 ARS
                </div>
                <div className="text-xs text-brand-gold group-hover:underline flex items-center justify-center gap-1" data-id="element-217">
                  QUIERO EL F500 ELITE <ArrowRightIcon size={14} data-id="element-218" />
                </div>
              </a>
            </div>

            <div className="mt-12 flex flex-wrap justify-center gap-6 text-xs text-gray-500 uppercase tracking-widest" data-id="element-219">
              <span className="flex items-center gap-1" data-id="element-220">
                <LockIcon size={14} data-id="element-221" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-222">
                <ZapIcon size={14} data-id="element-223" /> Acceso en 5 min
              </span>
              <span className="flex items-center gap-1" data-id="element-224">
                <ShieldCheckIcon size={14} data-id="element-225" /> Garantía 7 días
              </span>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-brand-darker border-t border-white/10 py-16 px-4" data-id="element-226">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-227">
          <div data-id="element-228">
            <div className="flex items-center gap-2 mb-6" data-id="element-229">
              <div className="w-8 h-8 bg-brand-green rounded flex items-center justify-center text-black font-black" data-id="element-230">
                F
              </div>
              <span className="font-montserrat font-extrabold text-xl tracking-tighter" data-id="element-231">
                F500 FREELANCE<span className="text-brand-green" data-id="element-232">™</span>
              </span>
            </div>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-233">
              El sistema N°1 para ganar tus primeros $500/mes como freelancer
              desde Latinoamérica. Porque trabajar en dólares desde tu casa no
              debería ser un misterio para nadie en Latam.
            </p>
            <div className="text-brand-green font-bold text-lg" data-id="element-234">
              "Tu primer $500 está a 30 días."
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8" data-id="element-235">
            <div data-id="element-236">
              <h4 className="font-bold mb-4 uppercase text-xs tracking-widest text-gray-500" data-id="element-237">
                Contacto
              </h4>
              <ul className="space-y-2 text-sm text-gray-400" data-id="element-238">
                <li data-id="element-239">soporte@guiadigital360.com</li>
                <li data-id="element-240">@guiadigital360</li>
                <li data-id="element-241">guiadigital360.com</li>
              </ul>
            </div>
            <div data-id="element-242">
              <h4 className="font-bold mb-4 uppercase text-xs tracking-widest text-gray-500" data-id="element-243">
                Legal
              </h4>
              <ul className="space-y-2 text-sm text-gray-400" data-id="element-244">
                <li data-id="element-245">© F500 Freelance™ 2026</li>
                <li data-id="element-246">guiadigital360</li>
                <li data-id="element-247">Todos los derechos reservados</li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}